import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@material-ui/core";
import { Card, CardHeader, CardContent } from "@material-ui/core";
import { Typography, Button, LinearProgress, Grid } from "@material-ui/core";

// Styles
import CurrentAssessmentStyle from "../../../assets/styles/materialUI/questionnaire/assessmentResult/CurrentAssessmentStyle";

export default function CurrentAssessment({ currentAssessment }) {
	const history = useHistory();
	const { t } = useTranslation();
	const classes = CurrentAssessmentStyle();
	const [continueAssessmentLoading, setContinueAssessmentLoading] = useState(false);

	const getStatusKey = (status) => {
		const normalized = (status || "").toLowerCase();
		if (normalized.includes("complete")) return "completed";
		if (normalized.includes("progress")) return "inProgress";
		return "notStarted";
	};

	const handleContinueAssessment = () => {
		setContinueAssessmentLoading(true);
		setTimeout(() => {
			setContinueAssessmentLoading(false);
			history.push("/questionnaire/assessment_form");
		}, 1000);
	};

	return (
		<Card className={classes.card}>
			<CardHeader title={t("assessment.results.current.title")} className={classes.cardHeader} />
			<CardContent>
				<Typography variant="subtitle1" gutterBottom>
					{t("assessment.results.current.startedOn", {
						value: currentAssessment.dateStarted ? currentAssessment.dateStarted : "-",
					})}
				</Typography>
				<LinearProgress
					variant="determinate"
					value={currentAssessment.progress ? Math.trunc(currentAssessment.progress) : 0}
					className={classes.progressBar}
				/>
				<Typography variant="body2" className={classes.progressTypography}>
					{t("assessment.results.current.progress", {
						value: currentAssessment.progress ? Math.trunc(currentAssessment.progress) : 0,
					})}
				</Typography>
				<Grid container justifyContent="space-between" alignItems="center" className={classes.actionContainer}>
					<Typography variant="subtitle2" className={classes.assessmentStatus}>
						{t("assessment.results.current.status", {
							value: t(`assessment.form.status.${getStatusKey(currentAssessment.status)}`),
						})}
					</Typography>
					<Button variant="contained" className={classes.button} onClick={handleContinueAssessment}>
						{continueAssessmentLoading ? (
							<CircularProgress size={26} className={classes.buttonLoading} />
						) : currentAssessment.status ? (
							t("assessment.results.current.continue")
						) : (
							t("assessment.results.current.start")
						)}
					</Button>
				</Grid>
			</CardContent>
		</Card>
	);
}
